import { INotificationAction } from '../../models/action.model';
import { RESET_UNREAD_COUNT, SET_UNREAD_COUNT } from './actionTypes';

interface NotificationsState {
  unreadCount: number;
}

const defaultStore: NotificationsState = {
  unreadCount: 0,
};

export default function notifications(
  state: NotificationsState = defaultStore,
  action: INotificationAction
) {
  switch (action.type) {
    case SET_UNREAD_COUNT:
      return {
        ...state,
        unreadCount: Math.max(0, action.payload), // Asegurar que no sea negativo
      };

    case RESET_UNREAD_COUNT:
      return {
        ...state,
        unreadCount: 0,
      };

    default:
      return state;
  }
}
